import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ROUTES } from '../../core/constants/routes';
import { useTickets } from '../../global/contexts/lottery/tickets';

import './styles/header.css';

const MENU = [
    { title: 'Inicio',      link: ROUTES.HOME,    isExact: true },
    { title: 'Tienda',      link: ROUTES.STORE },
    { title: 'Mis números', link: ROUTES.TICKETS, showsTicketCount: true },
];

function isActive(item, pathname) {
    return item.isExact ? pathname === item.link : pathname.startsWith(item.link);
}

export default function Header() {
    const { pathname } = useLocation();
    const { stats } = useTickets();
    const [isMenuOpen, setMenuOpen] = useState(false);

    // Every navigation closes the mobile sheet, otherwise it stays over the
    // page the visitor just opened.
    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="header">
            <div className="header__inner">
                <Link className="header__brand" to={ROUTES.HOME} aria-label="Rapichontico, inicio">
                    <img className="header__logo" src="/logo.png" alt="Rapichontico" />
                </Link>

                <button
                    className="header__hamburger"
                    onClick={() => setMenuOpen(open => !open)}
                    aria-label="Menú"
                    aria-expanded={isMenuOpen}
                >
                    {isMenuOpen ? '✖' : '☰'}
                </button>

                <nav className={`header__nav ${isMenuOpen ? 'header__nav--open' : ''}`}>
                    <ul className="header__menu">
                        {MENU.map(item => (
                            <li className="header__item" key={item.link}>
                                <Link
                                    to={item.link}
                                    className={`header__link ${isActive(item, pathname) ? 'header__link--active' : ''}`}
                                    onClick={closeMenu}
                                >
                                    {item.title}
                                    {item.showsTicketCount && stats.total > 0 && (
                                        <span className="header__badge">{stats.total}</span>
                                    )}
                                </Link>
                            </li>
                        ))}
                    </ul>

                    <Link
                        className="button button--primary button--sm header__cta"
                        to={ROUTES.STORE}
                        onClick={closeMenu}
                    >
                        Comprar número
                    </Link>
                </nav>
            </div>
        </header>
    );
}
